import { createReducer, on } from '@ngrx/store';
import { setQuotesAction } from './quotes.actions';



export const initialState = 1;

export const quotesReducer = createReducer(
  initialState,
  on(setQuotesAction, (state, { quote }) => quote)
);